(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-pro"] && !Shopify.designMode) return;
  try {
    

/*
=========================================================
BANNER PRO MARQUEE ENGINE
=========================================================

The user enters ONE copy of the text.

The script measures that copy and automatically creates
enough copies to fill the banner.

Speed is calculated using:

    duration = copy width / pixels per second

This keeps the physical scrolling speed consistent
regardless of the message length.
=========================================================
*/

(function () {

  function getBanners() {
    return document.querySelectorAll('[data-banner-pro]');
  }


  /*
  =======================================================
  PRESERVE TRAILING SPACES
  =======================================================
  */

  function preserveTrailingSpaces(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];
    let node;

    while (node = walker.nextNode()) {
      textNodes.push(node);
    }

    for (let i = textNodes.length - 1; i >= 0; i--) {
      const textNode = textNodes[i];
      const text = textNode.textContent;

      if (!text || text.trim() === '') {
        continue;
      }

      const match = text.match(/(\s+)$/u);

      if (match && match[1]) {
        const trailingWhitespace = match[1];

        const preservedWhitespace = trailingWhitespace.replace(
          / /g,
          '\u00A0'
        );

        textNode.textContent =
          text.slice(0, -trailingWhitespace.length) +
          preservedWhitespace;
      }

      break;
    }
  }


  /*
  =======================================================
  SETUP ONE BANNER
  =======================================================
  */

  function setupBanner(section) {
    if (!section) {
      return;
    }

    const track = section.querySelector('.bp-track');
    const originalCopy = section.querySelector('.bp-copy');
    const marquee = section.querySelector('.bp-marquee');

    if (!track || !originalCopy || !marquee) {
      return;
    }

    const originalHTML = originalCopy.innerHTML;

    track.style.animation = 'none';
    track.innerHTML = '';


    function createCopy() {
      const copy = document.createElement('span');

      copy.className = 'bp-copy';
      copy.innerHTML = originalHTML;

      preserveTrailingSpaces(copy);

      return copy;
    }


    const firstCopy = createCopy();
    track.appendChild(firstCopy);


    /*
    -------------------------------------------------------
    Wait for layout and fonts.
    -------------------------------------------------------
    */

    requestAnimationFrame(function () {

      const copyWidth =
        firstCopy.getBoundingClientRect().width;

      const containerWidth =
        marquee.getBoundingClientRect().width;


      if (copyWidth <= 0 || containerWidth <= 0) {
        return;
      }


      /*
      =====================================================
      CREATE ENOUGH COPIES

      Add more than the visible width so there is always
      content entering the viewport before the previous
      copy completes.
      =====================================================
      */

      const requiredCopies =
        Math.ceil(containerWidth / copyWidth) + 3;

      for (let i = 1; i < requiredCopies; i++) {
        track.appendChild(createCopy());
      }


      /*
      =====================================================
      MOVEMENT DISTANCE
      =====================================================
      */

      track.style.setProperty(
        '--bp-move',
        copyWidth + 'px'
      );


      /*
      =====================================================
      READ SPEED
      =====================================================
      */

      const computedStyle =
        window.getComputedStyle(section);

      const pixelsPerSecond =
        parseFloat(
          computedStyle.getPropertyValue('--bp-speed-px')
        );


      const speed =
        Number.isFinite(pixelsPerSecond) &&
        pixelsPerSecond > 0
          ? pixelsPerSecond
          : 110;


      /*
      =====================================================
      CALCULATE DURATION
      =====================================================
      */

      const duration =
        copyWidth / speed;

      track.style.setProperty(
        '--bp-duration',
        Math.max(duration, 0.05) + 's'
      );


      /*
      =====================================================
      RESTART ANIMATION
      =====================================================
      */

      track.style.animation = 'none';

      track.offsetHeight;

      track.style.animation = '';

    });
  }


  /*
  =======================================================
  SETUP ALL BANNERS
  =======================================================
  */

  function setupAllBanners() {
    getBanners().forEach(function (banner) {
      setupBanner(banner);
    });
  }


  /*
  =======================================================
  WAIT FOR FONTS
  =======================================================
  */

  function setupAfterFonts() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        setupAllBanners();
      });
    } else {
      setupAllBanners();
    }
  }


  /*
  =======================================================
  INITIAL LOAD
  =======================================================
  */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      setupAfterFonts
    );
  } else {
    setupAfterFonts();
  }


  /*
  =======================================================
  WINDOW LOAD
  =======================================================
  */

  window.addEventListener(
    'load',
    function () {
      setupAfterFonts();
    }
  );


  /*
  =======================================================
  RESIZE
  =======================================================
  */

  let resizeTimer;

  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(
        function () {
          setupAfterFonts();
        },
        150
      );
    },
    {
      passive: true
    }
  );


  /*
  =======================================================
  SHOPIFY THEME EDITOR
  =======================================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (
        event.detail &&
        event.detail.sectionId
      ) {
        const section =
          document.getElementById(
            'banner-pro-' +
            event.detail.sectionId
          );

        if (section) {
          setTimeout(
            setupAfterFonts,
            50
          );
        }
      }
    }
  );


  /*
  =======================================================
  SHOPIFY SECTION REORDER
  =======================================================
  */

  document.addEventListener(
    'shopify:section:reorder',
    function () {
      setTimeout(
        setupAfterFonts,
        50
      );
    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-link-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const fadeEls = document.querySelectorAll(".text-link-section.fade-in");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, { threshold: 0.1 });

  fadeEls.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
